import { createContext, useCallback, useContext } from 'react';

import { useTripsState } from '#states/hooks.js';

const InGuide = createContext(false);

/**
 * Marks guide content. A guide link rendered inside it — a markdown preview link, a map pin, a related
 * place — follows on from the guide (Back returns to it) instead of starting a new guide stack, so
 * shared components like `PreviewLink` and `MapWidget` behave right in chat and in a guide alike.
 */
export function GuideScope({ children }: { children: React.ReactNode }) {
  return <InGuide.Provider value>{children}</InGuide.Provider>;
}

/**
 * Opens a guide the way its caller's position calls for: pushed onto the guide stack inside a guide,
 * a new stack anywhere else.
 */
export function useOpenGuide(): (type: string, id: string) => void {
  const inGuide = useContext(InGuide);
  const tripsState = useTripsState();
  return useCallback(
    (type: string, id: string) => (inGuide ? tripsState.pushGuide(type, id) : tripsState.showGuide(type, id)),
    [inGuide, tripsState],
  );
}
